// extracted by mini-css-extract-plugin
export default {"navigationBarHeight":"72px","loadingSpinner":"Layout_loadingSpinner__nqB+V","contentContainer":"Layout_contentContainer__sGjx8","scrollableArea":"Layout_scrollableArea__4kafG"};